import React from 'react';
import './Footer.css';

const Footer = () => (
  <footer className="footer-container">
    <p className="footer-text">&copy; 2024 Информационная система мониторинга качества воздуха</p>
  </footer>
);

export default Footer;
